import { IHIVerificationState } from '@/shared/components/hi/HealthcareIdentifierForm'

export const DefaultIHIVerificationState: IHIVerificationState = {
  id: 'MED' as const,
  values: { number: '', expiry: '' },
  touched: { number: false, irn: false, expiry: false },
}
